import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonService } from 'src/app/core/_services/common.service';
import { NgxGalleryOptions } from '@kolkov/ngx-gallery';
import { NgxGalleryAnimation } from '@kolkov/ngx-gallery';
import { MainService } from 'src/app/core/_services/main.service';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { LocalStorageProvider } from 'src/app/core/_services/storage.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-review-detail-carousel',
  templateUrl: './review-detail-carousel.component.html',
  styleUrls: ['./review-detail-carousel.component.scss']
})
export class ReviewDetailCarouselComponent implements OnInit, OnDestroy {
  @Input() activeEstimate: any;
  @Input() allEstimates: any;
  @Input() inspection: boolean = false;
  @Output() priceShow = new EventEmitter<boolean>();
  @Output() lumpSumShow = new EventEmitter<boolean>();
  @Output() approveAllEstimates = new EventEmitter<boolean>();
  @Output() pay = new EventEmitter<boolean>();
  @Output() expandBundle = new EventEmitter<string>();
  @Input() inspectionTitle: string = '';
  @Input() workOrder: boolean = false;
  @Input() oppData: any;

  index: number = 0;
  hidePrice: boolean = false;
  lumpSum: boolean = true;
  galleryOptions: NgxGalleryOptions[] = [];
  galleryImages: any = [];
  isPreferredUser: boolean = false;
  currentIndex: number = -1;
  showFlag: any = false;
  inspectionBtn: any = [];
  activeEstimateStatus: any;
  selectedOption: 'lumpSum' | 'dollar' | null = null;

  flatNavList: any[] = [];

  private estimateSubscription: Subscription;

  constructor(
    private commonService: CommonService,
    private service: MainService,
    private storageService: LocalStorageProvider
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['allEstimates'] && this.allEstimates) {
      this.buildFlatNavList();
    }
  }

  ngOnInit(): void {
    this.isPreferredUser = this.storageService.getItem('CurrentUser')?.externalCompanyData?.isPreferred;
    this.buildFlatNavList();
    this.getDefaultStatus();
    this.getActiveEstimate();

    // if (this.allEstimates[0].isToggleOn) {
    //   this.hidePrice = true;
    //   this.priceShow.emit(true);
    // } else {
    //   this.hidePrice = false;
    //   this.priceShow.emit(false);
    // }

    if (this.inspection) {
      this.hidePrice = true;
      this.priceShow.emit(true);
    }
    this.lumpSum = true;
    this.lumpSumShow.emit(true);
    // if (this.allEstimates[0].isLumpSum) {
    // } else {
    //   this.lumpSum = false;
    //   this.lumpSumShow.emit(false);
    // }

    this.galleryOptions = [
      {
        width: '100%',
        height: '400px',
        preview: true,
        closeIcon: 'close',
        thumbnailsColumns: 4,
        imageAnimation: NgxGalleryAnimation.Slide,
        previewCloseOnEsc: true,
        previewCloseOnClick: true,
        imageArrows: true,
        previewKeyboardNavigation: true,
        imageArrowsAutoHide: true,
        thumbnailsArrows: true,
        previewZoom: true,
        thumbnailsRemainingCount: false,
        previewArrows: true,
        arrowPrevIcon: 'prev-arrow',
        arrowNextIcon: 'next-arrow',
      },
      {
        breakpoint: 800,
        width: '100%',
        height: '400px',
        imagePercent: 80,
        thumbnailsPercent: 20,
        thumbnailsMargin: 20,
        thumbnailMargin: 10,
        thumbnailsColumns: 3,
      },
      {
        breakpoint: 400,
        preview: true,
        thumbnailsColumns: 2,
      }
    ];

    this.setGalleryItems();
  }

  buildFlatNavList() {
    this.flatNavList = [];
    for (const item of this.allEstimates) {
      if ('noData' in item) continue;
      // if (item.isBundle) {
      //   item.childItems?.forEach(child => this.flatNavList.push(child));
      // } else {
      // }
      this.flatNavList.push(item);
    }
  }

  setGalleryItems() {
    const images = this.activeEstimate.itemImage
      .filter(item => this.isImage(item.link))
      .map(item => ({ image: item.link, thumbImage: item.link, title: '' }));

    const videos = this.activeEstimate.itemImage
      .filter(item => this.isVideo(item.link))
      .map(item => ({ video: item.link, thumbImage: item.link, title: '' }));

    this.galleryImages = [...images, ...videos];
  }

  isImage(link: string): boolean {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];
    return imageExtensions.some(ext => link.toLowerCase().endsWith(ext));
  }

  isVideo(link: string): boolean {
    const videoExtensions = ['mp4', 'avi', 'mov', 'wmv'];
    return videoExtensions.some(ext => link.toLowerCase().endsWith(ext));
  }

  setActiveEstimate(index: number) {
    this.commonService.setActiveEstimate(this.flatNavList[index]);
  }

  getActiveEstimate() {
    this.estimateSubscription?.unsubscribe();
    this.estimateSubscription = this.commonService.activeEstimate$.subscribe(activeEstimate => {
      if (activeEstimate) {
        this.activeEstimate = activeEstimate;
        this.index = this.setIndex(activeEstimate?._id);
        this.getDefaultStatus(activeEstimate?.inspectionId);
        this.setGalleryItems();
      }
    });
  }

  getDefaultStatus(id?: any) {
    this.service.get({}, `${API_ROUTES.OPPORTUNITY.getInspectionBtnStatus}`).subscribe(response => {
      if (response.status) {
        const initialData = response.data?.list;
        this.inspectionBtn = initialData;
        const foundEstimate = initialData.find((x) => x?._id == id);
        this.activeEstimateStatus = foundEstimate ? foundEstimate.fieldName : '';
      }
    });
  }

  setIndex(id: any): number {
    const idx = this.flatNavList.findIndex((item: any) => item._id === id);
    return idx !== -1 ? idx : 0;
  }

  previous() {
    if (this.index <= 0) return;
    this.index--;
    this.setActiveEstimate(this.index);
    const item = this.flatNavList[this.index];
    // if (item?.bundleInfo?.bundleInstanceId) {
    //   this.expandBundle.emit(item.bundleInfo.bundleInstanceId);
    // }
  }

  next() {
    if (this.index >= this.flatNavList.length - 1) return;
    this.index++;
    this.setActiveEstimate(this.index);
    const item = this.flatNavList[this.index];
    // if (item?.bundleInfo?.bundleInstanceId) {
    //   this.expandBundle.emit(item.bundleInfo.bundleInstanceId);
    // }
  }

  setStatus() {
    switch (this.activeEstimate?.inspectionStatus) {
      case 'Pass': return 'pass-status';
      case 'Pending': return 'pend-status';
      case 'Fail': return 'fail-status';
      default: return 'null-status';
    }
  }

  hidePriceDetails(e: any, type?: string) {
    if (type) {
      this.lumpSum = e.checked;
      this.lumpSumShow.emit(e.checked);
    } else {
      this.hidePrice = e.checked;
      this.priceShow.emit(e.checked);
    }
  }

  toggleOption(option: 'lumpSum' | 'dollar') {
    this.selectedOption = this.selectedOption === option ? null : option;
    if (this.selectedOption === 'lumpSum') {
      this.hidePriceDetails({ checked: true }, 'lS');
      this.hidePriceDetails({ checked: false });
    } else if (this.selectedOption === 'dollar') {
      this.hidePriceDetails({ checked: true });
      this.hidePriceDetails({ checked: false }, 'lS');
    } else {
      this.hidePriceDetails({ checked: false });
      this.hidePriceDetails({ checked: false }, 'lS');
    }
  }

  openPaymentPopUp() { this.pay.emit(true); }
  appEstimates() { this.approveAllEstimates.emit(true); }
  showLightbox(index) { this.currentIndex = index; this.showFlag = true; }
  closeEventHandler() { this.showFlag = false; this.currentIndex = -1; }

  setInspectionStatus(id: number): string {
    const foundBtn = this.inspectionBtn?.find(ele => ele?._id === id);
    if (foundBtn) {
      switch (foundBtn.originalName) {
        case 'Fail': return 'red-btn';
        case 'Pass': return 'pass-status';
        case 'Pending': return 'pend-status';
        case 'N/A': return 'grey-btn';
        default: return '';
      }
    }
    return '';
  }

  ngOnDestroy(): void {
    this.estimateSubscription?.unsubscribe();
  }
}
